import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import ReduxState from "./ReduxState";
import { UsersLogin } from "./SsoB3/SsoB3";
import { CtiCredential } from "./ServiceCti/ServiceCti";
import { SipUsers } from "./ServicePhone/SipUsers";
import { Users } from "./ServiceUsers/ServiceUsers";
import { Organization } from "./ServiceOrganization/ServiceOrganization";

export default combineReducers({
  form: formReducer,
  Users,
  Organization,
  SipUsers,
  CtiCredential,
  UsersLogin,
  ReduxState,
});
